// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_3Up2KlG7ZphBdHI7gc-4fs","image":"h8cB7Y1Qs1tIdmCsZ7L-R","letter":"_3O71B2TsaymNpHpYxcdPFS"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/avatar/theme.scss
// module id = 559
// module chunks = 0